export default "__VITE_PUBLIC_ASSET__823172a1__"